import { SessionService } from '@agenda-customer-ui/data-access';
import { inject, Injectable } from '@angular/core';

declare global {
  interface Window {
    dtrum?: {
      actionName(name: string): void;
      enterAction(name: string, type?: string, startTime?: number, sourceUrl?: string, sourceAction?: number): number;
      leaveAction(actionId: number, stopTime?: number, startTime?: number): void;
      reportCustomAction(name: string, type: string, startTime?: number, endTime?: number): void;
    };
  }
}

@Injectable({
  providedIn: 'root'
})
export class DynatraceService {
  readonly #sessionService = inject(SessionService);

  setVariableStorage(key: string, value: string): void {
    this.#sessionService.setItem(`DT${key}`, value);
  }

  removeVariableStorage(key: string): void {
    this.#sessionService.removeItem(`DT${key}`);
  }

  enterAction(actionName: string): number | undefined {
    return window.dtrum?.enterAction(actionName);
  }

  leaveAction(actionId: number): void {
    window.dtrum?.leaveAction(actionId);
  }

  trackClick(actionName: string): void {
    const actionId = this.enterAction(actionName);
    if (actionId !== undefined) {
      this.leaveAction(actionId);
    }
  }

  reportCustomAction(name: string, type: string): void {
    const now = Date.now();
    window.dtrum?.reportCustomAction(name, type, now, now);
  }

  isDynatraceAvailable(): boolean {
    return !!window.dtrum;
  }
}

